import "./App.css";
import { createTheme, ThemeProvider, useMediaQuery } from "@mui/material";
import { themeOptions } from './ThemeOptions.tsx';
import MenuBar from "./components/MenuBar.js";
import LandingPage from "./Pages/LandingPage/landingpage.js";
import AboutPage from "./Pages/AboutPage/AboutPage.js";
import EventsPage from "./Pages/EventsPage/EventsPage.js";
import FormsPage from "./Pages/FormsPage/FormsPage.js";
import BoardPage from "./Pages/BoardPage/BoardPage.js";
import { useState, useEffect, useLayoutEffect } from "react";
import { Route, Routes, BrowserRouter, useLocation, Navigate } from 'react-router-dom';
import LoginPage from "./Pages/LoginPage/LoginPage.js";

// Component for handling section scrolling
// Put this near App()
const ScrollToSection = ({ setActiveSection }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    const id = location.pathname.slice(1);
    if (!id) return;
    const el = document.getElementById(id);
    if (!el) return;
    requestAnimationFrame(() => {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      setActiveSection(id);
    });
  }, [location, setActiveSection]);

  return null;
};


function App() {
  const theme = createTheme(themeOptions);
  const isSmallScreen = useMediaQuery("(max-width:400px)");
  const [activeSection, setActiveSection] = useState("landing");

  // Monitor scroll to update active section
  useEffect(() => {
    const sections = document.querySelectorAll("section");

    const observer = new IntersectionObserver(
      (entries) => {
        let currentlyVisible = null;

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Track the currently visible section
            currentlyVisible = entry.target.id;
          }
        });

        if (currentlyVisible) {
          setActiveSection(currentlyVisible);
        }
      },
      {
        rootMargin: "-50% 0px -50% 0px", // Section must be fully within the viewport's middle 50%
      }
    );

    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  return (
    <div className="app-background">
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          {/* Handle scrolling to the section based on the route */}
          <ScrollToSection setActiveSection={setActiveSection} />
          
          <Routes>
            {/* Match the main page and any section-specific routes */}
            <Route
              path="/*"
              element={
                <>
                  <MenuBar activeSection={activeSection} setActiveSection={setActiveSection} />
                  <main>
                    <section id="landing">
                      <LandingPage activeSection={activeSection}/>
                    </section>
                    <section id="about">
                      <AboutPage activeSection={activeSection}/>
                    </section>
                    <section id="events">
                      <EventsPage activeSection={activeSection}/>
                    </section>
                    <section id="board">
                      <BoardPage activeSection={activeSection}/>
                    </section>
                    <section id="forms">
                      {/* <div className="form-entire-page" > */}
                      <FormsPage activeSection={activeSection}/>
                      {/* </div> */}
                    </section>
                  </main>
                  {isSmallScreen && <div className="footer" />}
                </>
              }
            />
            {/* Explicit login route */}
            <Route path="/AKFJSMCIEM" element={<LoginPage />} />
            {/* Redirect unknown paths to the landing page */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
}

export default App;
